// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mO_T","newExpiryDate":"styles_newExpiryDate__3b68z","footer":"styles_footer__26OZX"};